import React, { Fragment } from "react";
import { connect } from "react-redux";
import autoBind from "auto-bind";

import ModalChangeHtmlEditor from "@js/components/studio/campaign_content_section/modal_change_html_editor.jsx";
import ModalConfirmation from "./modal_confirmation.jsx";
import ModalDownloadContent from "@js/components/studio/campaign_content_section/modal_download_content.jsx";
import ModalEditName from "@js/components/studio/campaign_content_section/modal_edit_name.jsx";
import ModalEditSubject from "@js/components/studio/campaign_content_section/modal_edit_subject.jsx";
import ModalInsertCustomField from "@js/components/studio/campaign_content_section/modal_insert_custom_field.jsx";
import ModalInsertForm from "@js/components/studio/campaign_content_section/modal_insert_form.jsx";
import ModalPromptChangeInterface from "@js/components/studio/campaign_content_section/modal_prompt_change_interface.jsx";
import ModalRemoveAttachment from "./modal_remove_attachment.jsx";
import ModalUploadAttachment from "./modal_upload_attachment.jsx";
import ModalUploadFromFile from "@js/components/studio/campaign_content_section/modal_upload_from_file.jsx";
import ModalUploadFromUrl from "@js/components/studio/campaign_content_section/modal_upload_from_url.jsx";
import ModalSaveCustomRow from "@js/components/studio/campaign_content_section/modal_save_custom_row.jsx";
import ModalManageCustomRows from "@js/components/studio/campaign_content_section/modal_manage_custom_rows.jsx";

import ScreenEditor from "./screen_editor.jsx";
import ScreenViewRenderedPreview from "./screen_view_rendered_preview.jsx";
import ScreenViewWebVersion from "./screen_view_web_version.jsx";
import ScreenViewTextVersion from "./screen_view_text_version.jsx";

import StudioCampaignContentRow from "./studio_campaign_content_row.jsx";
import AttachmentsSection from "./attachments_section.jsx";

import { ceAddContent } from "@js/actions/studio/campaign_content_section/generate_content.js";
import { ceModalUploadAttachmentOpen } from "@js/actions/studio/campaign_content_section/modal_upload_attachment.js";

import EventConnector from "@js/helpers/event_connector.js";
import ModalConvertHTMLToText from "./modal_convert_html_to_text.jsx";

class StudioCampaignContentSection extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.editingConnector = new EventConnector();
  }

  render() {
    let contentLength = this.props.contents.length;

    let errorSection = this.props.error ? (
      <div className="alert alert-error">
        {typeof this.props.error === "string"
          ? this.props.error
          : t("phrases.react_content.error_saving")}
      </div>
    ) : (
      ""
    );

    return this.props.use_v1_editor ? (
      <div>
        {this.props.modal &&
          this.props.modal.name === "prompt_change_interface" && (
            <ModalPromptChangeInterface /> //We have to render this regardless of if we show the rest of the section
          )}
      </div>
    ) : (
      <div className="campaign-content-section">
        {errorSection}
        {this.props.contents.map((content, i) => {
          let isNotLastContent = i + 1 !== contentLength;
          return (
            <StudioCampaignContentRow
              key={i}
              content={content}
              isNotLastContent={isNotLastContent}
              isOnlyContent={contentLength === 1}
            />
          );
        })}
        {this.props.allowEditing && this._renderAddEntryButton()}
        <br />
        {this.props.attachments && this.props.attachments.length > 0 && (
          <h3 className="attachments-header">{t("sections.attachments")}</h3>
        )}
        <AttachmentsSection
          loading={this.props.attachmentLoading}
          attachments={this.props.attachments}
          allowEditing={this.props.allowEditing}
        />
        {this.props.screen && this.props.screen.name === "content_editor" && (
          <ScreenEditor connector={this.editingConnector} />
        )}
        {this.props.screen &&
          this.props.screen.name === "view_rendered_preview" && (
            <ScreenViewRenderedPreview />
          )}
        {this.props.screen && this.props.screen.name === "view_web_version" && (
          <ScreenViewWebVersion />
        )}
        {this.props.screen &&
          this.props.screen.name === "view_text_version" && (
            <ScreenViewTextVersion />
          )}

        {this.props.modal &&
          this.props.modal.name === "warn_before_screen_close" && (
            <ModalConfirmation />
          )}
        {this.props.modal && this.props.modal.name === "change_html_editor" && (
          <ModalChangeHtmlEditor />
        )}
        {this.props.modal && this.props.modal.name === "edit_name" && (
          <ModalEditName />
        )}
        {this.props.modal && this.props.modal.name === "edit_subject" && (
          <ModalEditSubject />
        )}
        {this.props.modal && this.props.modal.name === "modal_confirmation" && (
          <ModalConfirmation />
        )}
        {this.props.modal && this.props.modal.name === "remove_attachment" && (
          <ModalRemoveAttachment />
        )}
        {this.props.modal && this.props.modal.name === "upload_attachment" && (
          <ModalUploadAttachment />
        )}
        {this.props.modal && this.props.modal.name === "upload_from_file" && (
          <ModalUploadFromFile />
        )}
        {this.props.modal && this.props.modal.name === "upload_from_url" && (
          <ModalUploadFromUrl />
        )}
        {this.props.modal &&
          this.props.modal.name === "download_content_modal" && (
            <ModalDownloadContent />
          )}
        {this.props.modal &&
          this.props.modal.name === "campaign_image_select" && (
            <ModalCampaignImageSelect connector={this.editingConnector} />
          )}
        {this.props.modal && this.props.modal.name === "insert_form" && (
          <ModalInsertForm connector={this.editingConnector} />
        )}
        {this.props.modal &&
          this.props.modal.name === "insert_custom_field" && (
            <ModalInsertCustomField connector={this.editingConnector} />
          )}
        {this.props.modal &&
          this.props.modal.name === "convert_html_to_text" && (
            <ModalConvertHTMLToText />
          )}
        {this.props.modal &&
          this.props.modal.name === "prompt_change_interface" && (
            <ModalPromptChangeInterface />
          )}
        {this.props.modal &&
          this.props.modal.name === "save_custom_row" && (
            <ModalSaveCustomRow connector={ this.editingConnector } />
          )}
        {this.props.modal &&
          this.props.modal.name === "manage_custom_rows" && (
            <ModalManageCustomRows />
          )}
      </div>
    );
  }

  _addAttachment(fileObject, fileContent) {
    this.props.dispatch(
      ceAddAttachment(
        this.props.campaign_id,
        fileObject,
        fileContent,
        this.props.max_sizes,
      ),
    );
  }

  _deleteAttachment(attachmentID) {
    this.props.dispatch(
      ceDeleteAttachment(this.props.campaign_id, attachmentID),
    );
  }

  _renderAddEntryButton() {
    return (
      <div className="campaign-content-section-entry-long">
        <div className="pull-left">
          <a
            href="#"
            className="button"
            onClick={this._addHTMLContent}
          >
            {t("phrases.react_content.add_more_html")}
          </a>
          <a
            href="#"
            className="button"
            onClick={this._addTextContent}
          >
            {t("phrases.react_content.add_more_text")}
          </a>
          {(!this.props.attachments || this.props.attachments.length === 0) && (
            <a
              href="#"
              className="button"
              onClick={(e) => {
                e.preventDefault();
                this.props.dispatch(ceModalUploadAttachmentOpen());
              }}
            >
              {t("buttons.attach_a_file_to_this_campaign")}
            </a>
          )}
        </div>
      </div>
    );
  }

  _addTextContent(e) {
    e.preventDefault();
    this.props.dispatch(ceAddContent("text", "textarea"));
  }

  _addHTMLContent(e) {
    e.preventDefault();
    this.props.dispatch(ceAddContent("html", this.props.defaultHtmlEditor));
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
  beeUID: state.beeUID,
  error: state.error,
  bee_token: state.bee_token,
  attachments: state.data.attachments,
  attachmentError: state.attachmentError,
  attachmentLoading: state.attachmentLoading,
  contents: state.data.contents,
  screen: state.screen,
  modal: state.modal,
  allowEditing: state.library.allow_editing,
  defaultHtmlEditor: state.library.default_html_editor,
});

export default connect(mapStateToProps)(StudioCampaignContentSection);
